export class Gruppopersona {
  Codice: number;
  Gruppoid: number;
  Personaid: number;
}
